if (!window.__pbSizeGuideInitialized) {
window.__pbSizeGuideInitialized = true;
const pbLegacyCharts={
'full-size-ruched-satin-wrap-dress-with-sheer-mesh-sleeves-plus-size':{headers:['Size','Bust','Length','Sleeve'],rows:[['S','33.9','35','8.7'],['M','35.4','35.4','8.9'],['L','37.8','35.8','9.1'],['XL','40.2','36.2','9.3'],['2XL','42.5','36.6','9.4'],['3XL','44.9','37','9.6']]},
 'full-size-high-low-ruffled-satin-maxi-dress-plus-size':{headers:['Size','Bust','Length'],rows:[['S','33.9','55.1'],['M','35.4','55.5'],['L','37.8','55.9'],['XL','40.2','56.3'],['2XL','42.5','56.7']]},
 'sequin-tie-back-cami-dress':{headers:['Size','Bust','Waist','Length'],rows:[['XS','30.4','22.6','32.4'],['S','32','24.2','33'],['M','33.5','25.7','33.5'],['L','35.9','28.1','34.3'],['XL','38.2','30.4','35.1']]},
 'ruched-surplice-long-sleeve-dress':{headers:['Size','Bust','Length'],rows:[['S','37.8','37.4'],['M','39.4','37.8'],['L','41.7','38.2'],['XL','44.1','38.6'],['2XL','46.5','39']]},
 'bow-detail-sleeveless-dress':{headers:['Size','Bust','Length'],rows:[['S','30.3','33.9'],['M','31.9','34.3'],['L','33.9','34.6'],['XL','35.8','35'],['2XL','37.8','35.4']]},
 'embroidered-layered-single-shoulder-midi-dress':{"headers":["Size","US","Length","Bust","Waist","Hip"],"rows":[["XS","2","54.7","31.1","25.6","44.1"],["S","4","55.1","32.7","27.2","45.7"],["M","6/8","55.5","34.3","28.7","47.2"],["L","10/12","55.9","36.6","31.1","49.6"]]},
 'honey-slit-one-shoulder-short-sleeve-midi-dress':{"headers":["Size","US","Length","Bust","Waist","Hip"],"rows":[["S","4","49.2","35.4","28.3","38.2"],["M","6/8","49.6","37","29.9","39.8"],["L","10/12","50","39.4","32.3","42.1"],["XL","14","50.4","41.7","34.6","44.5"]]},
 'bow-tube-a-line-mini-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["XS","22.6","27.6-32.3","26"],["S","23.2","29.1-33.9","27.6"],["M","23.8","30.7-35.4","29.1"],["L","24.4","33.1-37.8","31.5"],["XL","25","35.4-40.2","33.9"]]},
 'one-shoulder-flutter-sleeve-asymmetrical-dress':{"headers":["Size","Front length","Bust","Waist","Hip","Sleeve"],"rows":[["S","47.8","32","26.9","34.3","5.3"],["M","48.6","34.3","29.3","36.7","5.5"],["L","49.3","36.7","31.6","39","5.7"],["XL","50.1","39.8","34.7","42.1","5.9"]]},
 'wide-strap-mesh-dress':{"headers":["Size","Front length","Bust","Waist","Hip"],"rows":[["XS","33.7","26.9","24.2","60.8"],["S","34.3","28.5","25.7","62.4"],["M","34.9","30","27.3","64"],["L","35.7","32.4","29.6","66.3"]]},
 'honey-tied-surplice-sleeveless-midi-cami-dress':{"headers":["Size","US","Length","Bust","Waist","Waist stretch"],"rows":[["S","4","43.1","35.4","25.6","41.7"],["M","6/8","43.9","37","27.2","43.3"],["L","10/12","44.7","39.4","29.5","45.7"],["XL","14","45.5","41.7","31.9","48"]]},
 'slit-floral-sequin-bodycon-maxi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","48","34.6","26"],["M","48.4","36.2","27.6"],["L","48.8","38.6","29.9"],["XL","49.2","40.9","32.3"]]},
 'asymmetrical-neck-ruched-midi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","32.3","34.6","26.4"],["M","32.7","36.2","28"],["L","33.3","38.6","30.3"],["XL","33.9","40.9","32.7"]]},
 'sequin-v-neck-long-sleeve-mini-dress':{"headers":["Size","Front length","Shoulder","Bust","Waist","Sleeve","Hip"],"rows":[["XS","31.4","14","32","25","22.6","31.2"],["S","32","14.4","33.5","26.5","23","32.8"],["M","32.6","14.8","35.1","28.1","23.4","34.3"],["L","33.3","15.4","37.4","30.4","24","36.7"]]},
 'ruched-square-neck-sleeve-mini-dress':{"headers":["Size","US","Length","Bust"],"rows":[["S","2/4","31.9","33.1"],["M","6/8","32.3","34.6"],["L","10","32.7","36.2"]]},
 'asymmetrical-neck-high-slit-maxi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","55.9","32.3","26.8"],["M","56.3","33.9","28.3"],["L","56.7","37","29.9"],["XL","57.1","38.6","31.5"],["2XL","57.5","40.2","33.1"]]},
 'sequin-spaghetti-strap-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["XS","32.6","28.1","23.8","53.8"],["S","33.2","29.6","25.4","55.4"],["M","33.7","31.2","26.9","56.9"],["L","34.5","33.5","29.3","59.3"],["XL","35.3","35.9","31.6","61.6"]]},
 'off-shoulder-layered-midi-dress':{"headers":["Size","Length","Bust","Waist","Sleeve"],"rows":[["XS","48.4","35.4","26.8","16.5"],["S","48.8","37","28.3","16.9"],["M","49.2","38.6","29.9","17.2"],["L","49.6","40.9","32.3","17.6"]]},
 'slit-lace-detail-maxi-cami-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","57.5","30.7-36.6","27.6","37"],["M","57.9","32.3-37.8","29.1","38.6"],["L","58.3","33.9-39.4","30.7","40.2"],["XL","58.7","35.4-40.9","32.3","41.7"]]},
 'satin-lace-trim-sleeveless-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","37.8","29.9-35.8","24.8-28.3","32.3-35.8"],["M","38.6","31.5-37.4","26.4-29.9","33.9-37.4"],["L","39.4","33.1-39","28-31.5","35.4-39"]]},
 'two-tone-flowing-maxi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","47","31.5","27.6"],["M","47.2","33.1","29.1"],["L","47.4","34.6","30.7"],["XL","47.6","36.2","32.3"],["2XL","47.8","37.8","33.9"]]},
 'pearl-strap-cowl-neck-satin-maxi-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["XS","51.2","33.1","25.6","34.3"],["S","51.6","34.3","26.8","35.4"],["M","52","35.8","28.3","37"],["L","52.4","38.2","30.7","39.4"]]},
 'slit-tie-shoulder-maxi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","48.8","33.1","26"],["M","49.2","34.6","27.6"],["L","49.6","37","29.9"],["XL","50","39.4","32.3"]]},
 'heathered-mock-neck-long-sleeve-mini-dress':{"headers":["Size","US","Length","Bust"],"rows":[["S","4","29.5","31.5"],["M","6/8","29.9","33.1"],["L","10/12","30.3","34.6"],["XL","14","30.7","36.2"]]},
 'full-size-sequin-fringe-v-neck-mini-dress-plus-size':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","31.5","34.6","26.8","37.8"],["M","31.9","36.2","28.3","39.4"],["L","32.3","37.8","29.9","40.9"],["XL","32.7","39.4","31.5","42.5"]]},
 'ruched-maxi-cami-dress':{"headers":["Size","US","Length","Bust","Waist"],"rows":[["S","4","46.9","29.5","23.6"],["M","6/8","47.2","31.1","25.2"],["L","10/12","47.6","33.5","27.6"],["XL","14","48","35.8","29.9"]]},
 'hyfve-flattering-fit-cami-maxi-dress':{"headers":["Size","Bust","Waist","Hip"],"rows":[["S","34-36","26-28","36-38"],["M","37-38","29-31","39-41"],["L","39-40","32-33","42-43"]]},
 'pu-slit-midi-dress':{"headers":["Size","Length","Bust","Waist"],"rows":[["S","45.6","32.8","27.3"],["M","46","34.3","28.9"],["L","46.4","36.7","31.2"],["XL","46.8","39","33.5"]]},
 'strapless-fringe-detail-mini-dress':{"headers":["Size","Front length","Bust","Waist","Hip"],"rows":[["XS","27","26","23","30"],["S","27","27","25","32"],["M","28","29","27","33"],["L","28","31","29","35"]]},
 'full-size-high-low-ruffled-zip-front-dress-plus-size':{"headers":["Size","Length","Bust"],"rows":[["S","54.7","36.2"],["M","55.1","37.8"],["L","55.5","40.2"],["XL","55.9","42.5"],["2XL","56.3","44.9"],["3XL","56.7","47.2"]]},
 'lace-deep-v-neck-maxi-dress':{"headers":["Size","Length","Bust","Waist","Shoulder","Sleeve"],"rows":[["XS","53.5","31.1","26.4","13.7","13.9"],["S","54.3","33.1","28.3","14.2","14.2"],["M","55.1","35","30.3","14.7","14.4"],["L","55.9","37","32.3","15.2","14.7"],["XL","56.7","39","34.3","15.7","15"],["2XL","57.5","42.1","37.4","16.5","15.3"]]},
 'sequin-one-shoulder-dress-with-high-slit':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","56.2","31.9","27.6","33.9"],["M","56.7","34.3","29.9","36.2"],["L","57.2","36.6","32.3","38.6"],["XL","57.6","39.8","35.4","41.7"]]},
 'glitter-surplice-long-sleeve-mini-dress':{"headers":["Size","Length","Bust","Shoulder","Sleeve"],"rows":[["S","33.90","35.83","13.58","24.17"],["M","34.65","38.19","14.17","24.57"],["L","35.39","40.55","14.76","24.96"],["XL","36.14","43.70","15.63","25.35"]]},
 'glitter-ruched-off-shoulder-mini-dress':{"headers":["Size","US","Length","Bust","Waist","Hip"],"rows":[["S","4","27.6","31.9","24.8","31.5"],["M","6/8","28.1","33.5","26.4","33.1"],["L","10/12","28.5","35.8","28.7","35.4"],["XL","14","28.9","38.2","31.1","37.8"]]},
 'long-sleeve-off-shoulder-ruched-dress':{"headers":["Size","Front length","Bust","Waist","Hip","Sleeve"],"rows":[["XS","38","26.5","21.8","26.5","14.8"],["S","38.6","28.1","23.4","28.1","15.2"],["M","39.2","29.6","25","29.6","15.6"],["L","40","32","27.3","32","16.2"]]},
 'cutout-round-neck-mini-dress':{"headers":["Size","Length","Bust","Waist","Hip","Sleeve"],"rows":[["XS","34.45","27.56","23.62","31.89","18.50"],["S","35.04","29.13","25.20","33.46","18.90"],["M","35.63","30.71","26.77","35.04","19.29"],["L","36.42","33.07","29.13","37.40","19.88"]]},
 'v-neck-long-sleeve-maxi-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","62.2","34.6","29.1","37.8"],["M","62.6","36.2","30.7","39.4"],["L","63","38.6","33.1","41.7"]]},
 'one-shoulder-sleeveless-high-low-dress':{"headers":["Size","Front length","Bust","Waist","Hip","Sleeve"],"rows":[["XS","55.4","27.3","25","60.8","13.7"],["S","56.2","28.9","26.5","62.4","14"],["M","56.9","30.4","28.1","64","14.4"],["L","58.1","32.8","30.4","66.3","15"]]},
 'sequin-notched-lantern-sleeve-maxi-dress':{"headers":["Size","Length","Bust","Sleeve"],"rows":[["S","53.5","37","23.2"],["M","53.9","38.6","23.6"],["L","54.3","40.9","24"],["XL","54.7","43.3","24.4"]]},
 'drawstring-ruched-long-sleeve-dress':{"headers":["Size","Bust","Waist","Hip","Sleeve","Length"],"rows":[["XS","27.3","22.2","30","21.8","39"],["S","28.9","23.8","31.6","22.2","39.6"],["M","30.4","25.4","33.2","22.6","40.2"],["L","32.8","27.7","35.5","23.2","41"]]},
 'off-shoulder-long-sleeve-lace-dress':{"headers":["Size","Front length","Bust","Sleeve"],"rows":[["S","32.5","33.9","20.7"],["M","33.2","35.9","21.1"],["L","33.8","38.2","21.5"],["XL","34.5","41.3","21.8"]]},
 'floral-short-sleeve-ruched-bodycon-midi-dress':{"headers":["Size","Length","Bust"],"rows":[["S","52","33.9"],["M","52.4","35.4"],["L","52.8","37.8"],["XL","53.1","40.2"],["2XL","53.5","42.5"]]},
 'velvet-slit-wide-strap-midi-dress':{"headers":["Size","Length","Bust","Waist","Hip"],"rows":[["S","44.5","30.7","23.6","31.5"],["M","45.1","32.3","25.2","33.1"],["L","45.9","34.6","27.6","35.4"],["XL","46.8","37","29.9","37.8"]]}
};
const pbDescriptionRoot=(dialog)=>dialog.closest('.pb-size-guide').querySelector('[data-pb-size-description]')?.content;
const pbProductHandle=(dialog)=>dialog.closest('.pb-size-guide')?.dataset.pbProductHandle||'';
const pbAvailableSizes=(dialog)=>((dialog.closest('.pb-size-guide').querySelector('[data-pb-size-options]')?.content?.textContent)||'').trim().split('|').map(size=>size.trim()).filter(Boolean);
const pbMeasurementLabel=(label)=>/bust|waist|hips?|length|chest|inseam|shoulder|sleeve|thigh|rise/i.test(label||'');
const pbFindSizeSource=(root)=>root?[...root.querySelectorAll('table')].find(t=>/\b(bust|waist|hips?|length|chest|inseam|shoulder|sleeve)\b/i.test(t.textContent||''))||null:null;
const pbExtractSize=(value)=>{
 const text=(value||'').trim();
 const match=text.match(/^(?:Size\s+)?(XXS|XS|S|M|L|XL|XXL|XXXL|[1-9]XL|[2-9]X|0XL|One Size)(?:\s*[·•|\/-]\s*US\s*[^ ]+|\s*\((?:US\s*)?[^)]+\))?$/i);
 return match?match[1]:'';
};
const pbLooksLikeSize=(value)=>!!pbExtractSize(value);
const pbDirectSizeHeading=(card)=>[...card.children].find(el=>/^(?:STRONG|H2|H3|H4)$/.test(el.tagName)&&pbLooksLikeSize(el.textContent));
const pbFindMeasurementCards=(root)=>{
 if(!root)return[];
 const candidates=[...root.querySelectorAll('.pb-card,.size-card,article,section,div')].filter(card=>{
  const heading=pbDirectSizeHeading(card);
  if(!heading)return false;
  const text=card.textContent||'';
  return /bust|waist|hips?|length|chest|shoulder|sleeve|inseam|thigh|rise/i.test(text);
 });
 return candidates.filter(card=>!candidates.some(other=>other!==card&&card.contains(other)));
};
const pbFindInlineRows=(root)=>root?[...root.querySelectorAll('div,p,li')].filter(el=>/^(?:XXS|XS|S|M|L|XL|XXL|XXXL|[1-9]XL|[2-9]X|0XL|One Size)\s*:/i.test((el.textContent||'').trim())&&/bust|waist|hips?|length|chest|shoulder|sleeve|inseam|thigh|rise/i.test(el.textContent||'')):[];
const pbSetOriginal=(cell,value,label)=>{
 if(pbMeasurementLabel(label)&&/-?\d/.test(value||''))cell.dataset.pbOriginal=value.trim();
};
const pbCloneMeasurementTable=(source)=>{
 const table=document.createElement('table');
 const headerLabels=[];
 [...source.rows].forEach((row,rowIndex)=>{
  const tr=document.createElement('tr');
  [...row.cells].forEach((cell,index)=>{
   const c=document.createElement(cell.tagName.toLowerCase());
   const value=(cell.textContent||'').trim();
   c.textContent=value;
   if(cell.colSpan>1)c.colSpan=cell.colSpan;
   if(cell.rowSpan>1)c.rowSpan=cell.rowSpan;
   if(rowIndex===0)headerLabels[index]=value;
   if(rowIndex>0)pbSetOriginal(c,value,headerLabels[index]);
   tr.append(c);
  });
  table.append(tr);
 });
 return table;
};
const pbReadCardValues=(card)=>{
 const values={};
 card.querySelectorAll('.measure').forEach(m=>{
  const label=(m.querySelector('span')?.textContent||'').trim();
  const value=(m.querySelector('strong')?.textContent||'').trim();
  if(label&&value)values[label]=value;
 });
 card.querySelectorAll('dl > div').forEach(row=>{
  const label=(row.querySelector('dt')?.textContent||'').trim();
  const value=(row.querySelector('dd')?.textContent||'').trim();
  if(label&&value)values[label]=value;
 });
 card.querySelectorAll('p').forEach(row=>{
  const label=(row.querySelector('strong,b')?.textContent||'').trim();
  const value=(row.querySelector('span')?.textContent||'').trim();
  if(label&&value&&pbMeasurementLabel(label))values[label]=value;
 });
 [...card.children].forEach(el=>{
  if(!/^(?:DIV|P|LI)$/.test(el.tagName))return;
  const text=(el.textContent||'').trim();
  const match=text.match(/^([^:]{1,40}):\s*(.+)$/);
  if(match&&pbMeasurementLabel(match[1]))values[match[1].trim()]=match[2].trim();
 });
 const rawLines=(card.innerText||'').split(/\n+/).map(x=>x.trim()).filter(Boolean);
 rawLines.forEach(line=>{
  if(pbLooksLikeSize(line))return;
  const match=line.match(/^([A-Za-z ]{2,30})\s+(.+)$/);
  if(match&&pbMeasurementLabel(match[1])&&/\d/.test(match[2]))values[match[1].trim()]=match[2].trim();
 });
 return values;
};
const pbTableFromCards=(cards)=>{
 const parsed=cards.map(card=>{
  const heading=pbDirectSizeHeading(card);
  const size=pbExtractSize(heading?.textContent||'');
  const values=pbReadCardValues(card);
  return{size,values};
 }).filter(r=>r.size&&Object.keys(r.values).length);
 const labels=[];
 parsed.forEach(r=>Object.keys(r.values).forEach(l=>{if(!labels.includes(l))labels.push(l)}));
 if(!parsed.length||!labels.length)return null;
 const table=document.createElement('table');
 const thead=document.createElement('thead');
 const hr=document.createElement('tr');
 ['Size',...labels].forEach(l=>{const th=document.createElement('th');th.textContent=l;hr.append(th)});
 thead.append(hr);table.append(thead);
 const tbody=document.createElement('tbody');
 parsed.forEach(r=>{
  const tr=document.createElement('tr');
  const sd=document.createElement('td');sd.textContent=r.size;tr.append(sd);
  labels.forEach(label=>{
   const td=document.createElement('td');
   const value=r.values[label]||'—';
   td.textContent=value;
   pbSetOriginal(td,value,label);
   tr.append(td);
  });
  tbody.append(tr);
 });
 table.append(tbody);
 return table;
};
const pbParseInlineRow=(text)=>{
 const match=(text||'').trim().match(/^((?:XXS|XS|S|M|L|XL|XXL|XXXL|[1-9]XL|[2-9]X|0XL|One Size))\s*:\s*(.+)$/i);
 if(!match)return null;
 const size=match[1].trim();
 const values={};
 match[2].split(',').forEach(part=>{
  const m=part.trim().match(/^(.+?)\s+(-?\d+(?:\.\d+)?(?:\s*[-–]\s*-?\d+(?:\.\d+)?)?\s*(?:in|cm)?)$/i);
  if(m&&pbMeasurementLabel(m[1]))values[m[1].trim()]=m[2].trim();
 });
 return Object.keys(values).length?{size,values}:null;
};
const pbTableFromInlineRows=(rows)=>{
 const parsed=rows.map(row=>pbParseInlineRow(row.textContent||'')).filter(Boolean);
 const labels=[];
 parsed.forEach(r=>Object.keys(r.values).forEach(l=>{if(!labels.includes(l))labels.push(l)}));
 if(!parsed.length||!labels.length)return null;
 const table=document.createElement('table');
 const thead=document.createElement('thead');
 const hr=document.createElement('tr');
 ['Size',...labels].forEach(l=>{const th=document.createElement('th');th.textContent=l;hr.append(th)});
 thead.append(hr);table.append(thead);
 const tbody=document.createElement('tbody');
 parsed.forEach(r=>{
  const tr=document.createElement('tr');
  const sd=document.createElement('td');sd.textContent=r.size;tr.append(sd);
  labels.forEach(label=>{
   const td=document.createElement('td');
   const value=r.values[label]||'—';
   td.textContent=value;
   pbSetOriginal(td,value,label);
   tr.append(td);
  });
  tbody.append(tr);
 });
 table.append(tbody);
 return table;
};
const pbTableFromLegacy=(chart)=>{
 const table=document.createElement('table');
 const thead=document.createElement('thead');
 const hr=document.createElement('tr');
 chart.headers.forEach(h=>{const th=document.createElement('th');th.textContent=h;hr.append(th)});
 thead.append(hr);table.append(thead);
 const tbody=document.createElement('tbody');
 chart.rows.forEach(row=>{
  const tr=document.createElement('tr');
  row.forEach((value,index)=>{const td=document.createElement('td');td.textContent=value;if(index>0)pbSetOriginal(td,value,chart.headers[index]);tr.append(td)});
  tbody.append(tr);
 });
 table.append(tbody);
 return table;
};
const pbVerifiedUsMap=(dialog)=>{
 try{
  const value=JSON.parse(dialog.closest('.pb-size-guide')?.dataset.pbVerifiedUsMap||'null');
  return value&&typeof value==='object'&&!Array.isArray(value)?value:{};
 }catch{return{}}
};
const pbUsLabel=(map,size)=>{
 const raw=String(map[size]??'').replace(/^US\s*/i,'').trim();
 return /^(?:00|0|[1-9]\d?)$/.test(raw)?'US '+raw:'';
};
const pbStoreUsLabel=(size,has1xl=false)=>({
 XXS:'US 0',XS:'US 2',S:'US 4',M:'US 6',L:'US 8',
 XL:'US 10','1XL':'US 12','2XL':has1xl?'US 14':'US 12',XXL:'US 12',
 '3XL':has1xl?'US 16':'US 14',XXXL:'US 14','4XL':has1xl?'US 18':'US 16'
 })[String(size||'').toUpperCase()]||'';
const pbDisplayUsLabel=(map,size,has1xl=false)=>pbUsLabel(map,size)||pbStoreUsLabel(size,has1xl);
const pbBuildSizeNav=(dialog,chart)=>{
 const list=dialog.querySelector('[data-pb-size-list]');
 if(!list)return;
 const rows=chart?[...chart.rows].slice(1):[];
 const available=pbAvailableSizes(dialog);
 const has1xl=available.includes('1XL');
 const sizes=[...new Set((rows.length?rows.map(row=>pbExtractSize(row.cells[0]?.textContent||'')||(row.cells[0]?.textContent||'').trim()).filter(size=>!available.length||available.includes(size)):available).filter(Boolean))];
 const map=pbVerifiedUsMap(dialog);
 list.replaceChildren();
 if(!sizes.length){dialog.querySelector('.pb-size-guide__size-nav')?.setAttribute('hidden','');return}
 const choose=(size)=>{
  list.querySelectorAll('button').forEach(button=>{const selected=button.dataset.pbSize===size;button.classList.toggle('is-active',selected);button.setAttribute('aria-pressed',String(selected))});
  rows.forEach(row=>row.classList.toggle('pb-size-guide__row-selected',size!==''&&(pbExtractSize(row.cells[0]?.textContent||'')||(row.cells[0]?.textContent||'').trim())===size));
 };
 ['',...sizes].forEach(size=>{
  const button=document.createElement('button');
  button.type='button';
  button.dataset.pbSize=size;
  button.textContent=size?(pbDisplayUsLabel(map,size,has1xl)||size):'Overall';
  button.addEventListener('click',()=>choose(size));
  list.append(button);
 });
 choose('');
};
const pbLoadChart=(dialog)=>{
 const dest=dialog.querySelector('[data-pb-product-chart]');
 if(dest.dataset.loaded)return;
 const root=pbDescriptionRoot(dialog);
 const source=pbFindSizeSource(root);
 const cards=pbFindMeasurementCards(root);
 const inlineRows=pbFindInlineRows(root);
 const legacy=pbLegacyCharts[pbProductHandle(dialog)];
 dest.replaceChildren();
 if(source){
  dest.append(pbCloneMeasurementTable(source));
 }else if(cards.length){
  const table=pbTableFromCards(cards);
  if(table)dest.append(table);
 }else if(inlineRows.length){
  const table=pbTableFromInlineRows(inlineRows);
  if(table)dest.append(table);
 }else if(legacy){
  dest.append(pbTableFromLegacy(legacy));
 }else{
  const sizes=pbAvailableSizes(dialog);
  const p=document.createElement('p');
  p.textContent=sizes.length?'Detailed garment measurements are not available for this dress. Available sizes: '+sizes.join(', ')+'.':'Detailed garment measurements are not available for this dress.';
  dest.append(p);
 }
 const chart=dest.querySelector('table');
 if(chart && chart.rows.length){
  const headers=[...chart.rows[0].cells].map(cell=>(cell.textContent||'').trim());
  const unverifiedUs=[];
  headers.forEach((label,index)=>{if(/^(?:estimated\s+)?US(?:\s+size)?$/i.test(label))unverifiedUs.push(index)});
  unverifiedUs.sort((a,b)=>b-a).forEach(index=>[...chart.rows].forEach(row=>row.cells[index]?.remove()));
  const headerCells=[...chart.rows[0].cells];
  const baseLabel=label=>label.replace(/\s*(?:\((?:in|cm|inches)\)|\b(?:inches|cm)\b)\s*$/i,'').trim();
  const redundantCm=[];
  headerCells.forEach((cell,index)=>{
   const label=(cell.textContent||'').trim();
   if(/(?:\(cm\)|\bcm\b)\s*$/i.test(label)&&headerCells.some((other,otherIndex)=>otherIndex!==index&&baseLabel(other.textContent||'').toLowerCase()===baseLabel(label).toLowerCase()&&/(?:\(in\)|\binches\b)\s*$/i.test(other.textContent||'')))redundantCm.push(index);
  });
  redundantCm.sort((a,b)=>b-a).forEach(index=>[...chart.rows].forEach(row=>row.cells[index]?.remove()));
  [...chart.rows[0].cells].forEach((head,index)=>{
   const label=(head.textContent||'').trim();
   if(!pbMeasurementLabel(label))return;
   const base=baseLabel(label);
   const fromCm=/(?:\(cm\)|\bcm\b)\s*$/i.test(label);
   head.dataset.pbHeaderBase=base;
   head.textContent=base+' (in)';
   [...chart.rows].slice(1).forEach(row=>{
    const cell=row.cells[index];
    if(!cell||!/-?\d/.test(cell.textContent||''))return;
    if(/^(bust|chest|waist|hips?)$/i.test(base)&&/^0+(?:\.0+)?$/.test((cell.textContent||'').trim())){cell.textContent='—';delete cell.dataset.pbOriginal;return}
    if(fromCm)cell.textContent=(cell.textContent||'').replace(/-?\d+(?:\.\d+)?/g,n=>String(Math.round(parseFloat(n)/2.54*4)/4));
    cell.dataset.pbOriginal=(cell.textContent||'').trim();
   });
  });
  const shownSizes=[...chart.rows].slice(1).map(row=>pbExtractSize(row.cells[0]?.textContent||'')||(row.cells[0]?.textContent||'').trim());
  const missingSizes=pbAvailableSizes(dialog).filter(size=>!shownSizes.includes(pbExtractSize(size)||size));
  if(missingSizes.length){
   const note=document.createElement('p');
   note.className='pb-size-guide__tip';
   note.textContent='Measurements are not available here for '+missingSizes.join(', ')+'. Please contact us for sizing help before ordering.';
   dest.append(note);
  }
  const verifiedUs=pbVerifiedUsMap(dialog);
  const has1xl=pbAvailableSizes(dialog).includes('1XL');
  if(shownSizes.length&&shownSizes.some(size=>pbDisplayUsLabel(verifiedUs,size,has1xl))){
   const heading=document.createElement('th');
   heading.textContent='US size';
   chart.rows[0].cells[0]?.after(heading);
   [...chart.rows].slice(1).forEach((row,index)=>{
    const cell=document.createElement('td');
    cell.textContent=pbDisplayUsLabel(verifiedUs,shownSizes[index],has1xl)||'See guide';
    row.cells[0]?.after(cell);
   });
  }
 }
 pbBuildSizeNav(dialog,chart);
 dest.dataset.loaded='1';
};
const pbConvertMeasurement=(value,unit)=>{
 if(unit!=='cm')return value;
 const converted=value.replace(/-?\d+(?:\.\d+)?/g,n=>(parseFloat(n)*2.54).toFixed(1));
 return converted.replace(/\s*in(?:ches)?\b/gi,' cm');
};
const pbUnits=(dialog,unit)=>{
 dialog.querySelectorAll('[data-pb-unit]').forEach(b=>b.classList.toggle('is-active',b.dataset.pbUnit===unit));
 dialog.querySelectorAll('[data-pb-original]').forEach(c=>{c.textContent=unit==='cm'?(c.dataset.pbCm||pbConvertMeasurement(c.dataset.pbOriginal,'cm')):c.dataset.pbOriginal});
 dialog.querySelectorAll('[data-pb-header-base]').forEach(c=>{c.textContent=c.dataset.pbHeaderBase+(unit==='cm'?' (cm)':' (in)')});
};
const pbTab=(dialog,name)=>{
 dialog.querySelectorAll('[data-pb-guide-tab]').forEach(button=>{
  const active=button.dataset.pbGuideTab===name;
  button.classList.toggle('is-active',active);
  button.setAttribute('role','tab');
  button.setAttribute('aria-selected',String(active));
 });
 dialog.querySelectorAll('[data-pb-guide-panel]').forEach(panel=>panel.hidden=panel.dataset.pbGuidePanel!==name);
 const footer=dialog.querySelector('[data-pb-show-finder]');
 if(footer)footer.textContent=name==='finder'?'View measurements':"What's my size?";
};
const pbFindSize=(form)=>{
 const dialog=form.closest('dialog');
 const result=dialog.querySelector('[data-pb-finder-result]');
 const chart=dialog.querySelector('[data-pb-product-chart] table');
 const entered=['bust','waist','hip'].map(name=>Number(form.elements[name]?.value));
 if(entered.some(value=>!Number.isFinite(value)||value<=0)){result.textContent='Enter all three measurements in centimetres.';return}
 if(!chart){result.textContent='A product-specific chart is not available for this dress. Please contact us for sizing help.';return}
 const headings=[...chart.rows[0].cells].map(cell=>(cell.dataset.pbHeaderBase||cell.textContent||'').trim().toLowerCase());
 const indices=[/^(bust|chest)$/, /^waist$/, /^hips?$/].map(pattern=>headings.findIndex(label=>pattern.test(label)));
 if(indices.includes(-1)){result.textContent='This dress does not have all three bust, waist, and hip measurements. We cannot calculate a size from an incomplete chart.';return}
 const parseInches=value=>{
  const text=String(value||'').trim();
  return /^\d+(?:\.\d+)?(?:\s*in)?$/i.test(text)&&parseFloat(text)>0?parseFloat(text):NaN;
 };
 const available=pbAvailableSizes(dialog);
 const rows=[...chart.rows].slice(1).filter(row=>{
  const size=pbExtractSize(row.cells[0]?.textContent||'')||(row.cells[0]?.textContent||'').trim();
  return available.includes(size);
 });
 if(!rows.length){result.textContent='The chart sizes do not match this dress’s available sizes. Please contact us for sizing help.';return}
 const complete=rows.every(row=>indices.every(index=>Number.isFinite(parseInches(row.cells[index]?.dataset.pbOriginal||row.cells[index]?.textContent))));
 if(!complete){result.textContent='Some listed measurements are ranges or are missing. We cannot calculate a dependable size for this dress.';return}
 const candidates=rows.filter(row=>indices.every((index,axis)=>parseInches(row.cells[index]?.dataset.pbOriginal||row.cells[index]?.textContent)*2.54>entered[axis]));
 const candidate=candidates.sort((a,b)=>parseInches(a.cells[indices[0]]?.dataset.pbOriginal||a.cells[indices[0]]?.textContent)-parseInches(b.cells[indices[0]]?.dataset.pbOriginal||b.cells[indices[0]]?.textContent))[0];
 if(!candidate){result.textContent='None of the available garment sizes exceeds all three measurements you entered. Please contact us for help before ordering.';return}
 const size=pbExtractSize(candidate.cells[0]?.textContent||'')||(candidate.cells[0]?.textContent||'').trim();
 const us=pbDisplayUsLabel(pbVerifiedUsMap(dialog),size,available.includes('1XL'));
 result.textContent='Store size to review: '+size+(us?' ('+us+')':'')+'. Its listed bust, waist, and hip measurements are larger than yours. Check how much room you prefer and the fabric details.';
 dialog.querySelectorAll('[data-pb-size-list] button').forEach(button=>{if(button.dataset.pbSize===size)button.click()});
};
document.addEventListener('click',e=>{
 const open=e.target.closest('[data-pb-size-guide-open]');
 if(open){const d=open.closest('.pb-size-guide').querySelector('dialog');pbLoadChart(d);pbTab(d,'chart');d.addEventListener('close',()=>open.focus(),{once:true});d.showModal();return}
 const close=e.target.closest('[data-pb-size-guide-close]');
 if(close){close.closest('dialog').close();return}
 const tab=e.target.closest('[data-pb-guide-tab]');
 if(tab){pbTab(tab.closest('dialog'),tab.dataset.pbGuideTab);return}
 const showFinder=e.target.closest('[data-pb-show-finder]');
 if(showFinder){const d=showFinder.closest('dialog');const isFinder=!d.querySelector('[data-pb-guide-panel="finder"]').hidden;pbTab(d,isFinder?'chart':'finder');(isFinder?d.querySelector('[data-pb-product-chart]'):d.querySelector('[name="bust"]'))?.focus();return}
 const unit=e.target.closest('[data-pb-unit]');
 if(unit){pbUnits(unit.closest('dialog'),unit.dataset.pbUnit);return}
 const d=e.target.closest('[data-pb-size-guide-dialog]');
 if(d&&e.target===d)d.close();
});
document.addEventListener('submit',e=>{
 const form=e.target.closest('[data-pb-size-finder]');
 if(!form)return;
 e.preventDefault();
 pbFindSize(form);
});
}
